export const FETCH_TRAINER = 0;
export const CREATE_TRAINER = 1;
